import { awaitPendingAction, clearPendingAction } from '../actions/pending';

export default function awaitPendingActions() {
  return next => (action) => {
    next(action);

    if (!action.payload || !action.payload.then) return;

    const id = `${action.type}:${Date.now()}`;

    const promise = action.payload
      .then(() => next(clearPendingAction(id)))
      .catch(() => {
        next(clearPendingAction(id));
        // TODO - Should we report this to the server
        console.info('Pending action rejected', id);
      });

    next(awaitPendingAction({ id, promise }));
  };
}



// WEBPACK FOOTER //
// ./src/universal/ui/middleware/await-pending-actions.js